<div class="modal-header">
    <label class="modal-title">Attachments</label>
    <button class="close" type="button" (click)="closeModal()" aria-label="Close">x</button>
</div>

<div class="modal-body">
    <div class="table-responsive">
        <table class="table table-striped table-bordered table-hover table-condensed fixed">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Size</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of attachmentsModel">
                    <td><a (click)="OpenAttachment(item.fileServiceId, item?.fileName)" tabindex="0" (keyup.enter)="OpenAttachment(item.fileServiceId, item?.fileName)">
                        {{ item?.fileName }}</a></td>
                    <td nowrap>{{ item?.size/1024/1024 | number:'.3' }} MB</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="mb-2">
        <progressbar [value]="progressBarValue" *ngIf="showProgressBar">
            <span class="text-nowrap">Download in progress</span>
        </progressbar>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="closeModal()">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
            class="svg-inline--fa fa-times fa-w-11" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" aria-labelledby="close">
            <title id="close">Close</title>
            <desc>A x mark to indicate close.</desc>
            <path fill="currentColor"
                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
            </path>
        </svg>&nbsp;{{closeBtnName}}
    </button>
</div>